import React from "react"
import { FaFacebook, FaTwitterSquare, FaSquarespace } from "react-icons/fa"
export default [
  {
    icon: <FaFacebook />,
    url: "https://twitter.com/?lang=en",
  },
  {
    icon: <FaTwitterSquare />,
    url: "https://twitter.com/?lang=en",
  },
  {
    icon: <FaSquarespace />,
    url: "https://twitter.com/?lang=en",
  },
]
